import { Component, OnInit } from '@angular/core';
import { TitleService } from '@kservice';

@Component({
  selector: 'kp-screen-feedback',
  templateUrl: './screen-feedback.component.html',
  styleUrls: ['./screen-feedback.component.scss'],
})
export class ScreenFeedbackComponent implements OnInit {
  private _title = 'Feedback';
  constructor(private titleService: TitleService) {}

  ngOnInit() {
    this.titleService.set(this._title);
  }
}
